import { createApp } from 'vue/dist/vue.esm-bundler'

import App from '../pages/contact/App.js'

document.addEventListener('DOMContentLoaded', () => {
  createApp(App).mount('main')
})
